import { Injectable } from '@angular/core';

@Injectable()
export class SourcesService {

  constructor() {

  }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/sources/sources.service.ts